import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { cognitoRedirectUrl } from '@app/shared/auth/auth.config';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    if (!this.authService.isLoggedIn()) {
      window.location.href = cognitoRedirectUrl;
      return of(false);
    }

    if (!this.authService.isSessionExpired()) {
      return of(this.router.createUrlTree(['/home']));
    }

    return this.authService.refreshToken().pipe(
      map((authResult) => {
        if (authResult) {
          this.authService.handleRefreshResponse(authResult);
          return this.router.createUrlTree(['/home']);
        }

        return false;
      }),
      catchError(() => {
        this.authService.clear();
        window.location.href = cognitoRedirectUrl;
        return of(false);
      }),
    );
  }
}
